import request from "./request"
import { AxiosResponse } from "axios"

const getProducts = async (): Promise<AxiosResponse<any>> => {
    const resp = await request.get("stock")

    return resp.data
}

export default getProducts